export default __webpack_public_path__ + "locales/ru/VersionHistory.json?hash=585fca1f1f65291ae68f14e193dbc76a";